import { useEffect, useRef, type ReactNode } from "react";
/** Native modal supplies focus containment, Escape and inert background; restore its opener. */
export function ViewerDialog({title,onClose,children}:{title:string;onClose():void;children:ReactNode}) {
  const ref=useRef<HTMLDialogElement>(null);
  useEffect(()=>{
    const opener=document.activeElement instanceof HTMLElement?document.activeElement:null;
    const dialog=ref.current;dialog?.showModal();
    return ()=>{dialog?.close();opener?.focus();};
  },[]);
  return <dialog ref={ref} className="viewer-dialog" aria-label={title} onCancel={e=>{e.preventDefault();onClose();}}>
    <header><h2>{title}</h2><button type="button" aria-label={`Close ${title}`} onClick={onClose}>Close</button></header>{children}
  </dialog>;
}
